import { Checkbox, CircularProgress, Container, Fab, FormControlLabel, Grid, MenuItem, TextField, Tooltip, Typography } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import demandService from '../../api/demandsService';
import { cleanDemand } from '../../redux/actions/demandActions';
import { showSuccess, showWarning } from '../../redux/actions/snackbarActions';
import { distinct } from '../../shared/helpers/distinctArray';
import { getSelectOptions } from '../../shared/helpers/selectHelper';
import GoldenDemandCard from './GoldenDemandCard';




const GoldenDemandsScreen = ({ demands, showSuccess, cleanDemand, cities, states, categories }) => {
    const { push } = useHistory();
    const [onlyActive, setOnlyActive] = useState(true);
    const [selectedStateCode, setSelectedStateCode] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubcategory, setSelectedSubcategory] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function buscarDados() {
            setLoading(true);
            await demandService.getAllGoldenDemands();
            setLoading(false);
        }
        buscarDados();
        return () => {
            cleanDemand();
        }
    }, demands);

    const getTimeSince = (date) => {
        const seconds = Math.floor((new Date() - date) / 1000);
        let interval = Math.floor(seconds / 31536000);

        if (interval > 1) {
            return interval + " years";
        }
        interval = Math.floor(seconds / 2592000);

        if (interval > 1) {
            return interval + " months";
        }
        interval = Math.floor(seconds / 86400);

        if (interval > 1) {
            return interval + " days";
        }
        interval = Math.floor(seconds / 3600);

        if (interval > 1) {
            return interval + " hours";
        }
        interval = Math.floor(seconds / 60);

        if (interval > 1) {
            return interval + " minutes";
        }
        return Math.floor(seconds) + " seconds";
    }

    if (loading) {
        return (<div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress variant="indeterminate" color="secondary" />
        </div>);
    }

    const citiesFiltered = selectedStateCode !== '' ?
        distinct(cities.filter((city) => city.stateCode === selectedStateCode), "value")
        :
        [];


    return (
        <Container>
            <Typography variant="h4">My Golden Demands </Typography><Typography variant="body2">({demands[0]?.companyName})</Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={onlyActive}
                        onChange={({ target }) => setOnlyActive(target.checked)}
                    />
                }
                label="Show only active demands"
            />

            <Grid container>
                <Grid item xs={6} sm={3} style={{ padding: 10 }}>
                    <TextField
                        select
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="State"
                        type="text"
                        onChange={({ target }) => setSelectedStateCode(target.value)}
                        value={selectedStateCode}
                        fullWidth
                    >
                        {[<MenuItem value={""}>Choose a state...</MenuItem>, getSelectOptions(states)]}
                    </TextField>
                </Grid>

                <Grid item xs={6} sm={3} style={{ padding: 10 }}>
                    <TextField
                        select
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="City"
                        type="text"
                        onChange={({ target }) => setSelectedCity(target.value)}
                        value={selectedCity}
                        fullWidth
                    >
                        {[<MenuItem value={""}>Choose a city...</MenuItem>, getSelectOptions(citiesFiltered)]}
                    </TextField>
                </Grid>
                <Grid item xs={6} sm={3} style={{ padding: 10 }}>
                    <TextField
                        select
                        label="Category"
                        value={selectedCategory}
                        onChange={({ target }) => setSelectedCategory(target.value)}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                    >
                        {[<MenuItem value={""}>Choose a category...</MenuItem>, getSelectOptions(categories.map((category) => ({ value: category.name, display: category.name })))]}
                    </TextField>
                </Grid>
                <Grid item xs={6} sm={3} style={{ padding: 10 }}>
                    <TextField
                        select
                        label="Subcategory"
                        value={selectedSubcategory}
                        onChange={({ target }) => setSelectedSubcategory(target.value)}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                    >
                        {
                            selectedCategory !== '' ?
                                [<MenuItem value={""}>Choose a subcategory...</MenuItem>, getSelectOptions(categories
                                    .filter((cat) => cat.name === selectedCategory)[0].subcategories
                                    .map((category) => ({ value: category.name, display: category.name })))]
                                :
                                <MenuItem value={""}>Choose a category...</MenuItem>
                        }
                    </TextField>
                </Grid>
                {
                    demands
                        .filter(demand => onlyActive ? demand.isActive : true)
                        .filter(demand => selectedStateCode === '' ? true : demand.stateCode === selectedStateCode)
                        .filter(demand => selectedCity === '' ? true : demand.city === selectedCity)
                        .filter(demand => selectedCategory === '' ? true : demand.category === selectedCategory)
                        .filter(demand => selectedSubcategory === '' ? true : demand.subcategory === selectedSubcategory)
                        .map((demand) => {
                            console.log(demand);
                            return (
                                <Grid item xs={12} sm={6} md={6} lg={4} style={{ padding: 5 }}>
                                    <GoldenDemandCard
                                        id={demand.id}
                                        key={demand.id}
                                        category={demand.category}
                                        subcategory={demand.subcategory}
                                        description={demand.description}
                                        isFullTime={demand.isFullTime}
                                        location={`${demand.city}, ${demand.stateCode}`}
                                        zipCode={demand.zipCode}
                                        timeAgo={getTimeSince(new Date(demand.creationDate))}
                                        isActive={demand.isActive}
                                        isExclusive={demand.isExclusive}
                                        onDeactivateClick={async (idDemand, isActive) => {
                                            try {
                                                await demandService.changeStatus(idDemand, isActive);
                                                showSuccess('Demand saved successfully.');
                                                demandService.getAllGoldenDemands();
                                            } catch (e) { }
                                        }}
                                    />
                                </Grid>
                            )
                        })
                }
            </Grid>
            <Tooltip title="Create a new Golden Demand">
                <Fab variant="extended" color="secondary" aria-label="add" onClick={() => push('/goldendemand/create')}
                    style={{ position: 'fixed', bottom: 24, right: 24 }}>
                    <AddIcon />
                    Golden Demands
                </Fab>
            </Tooltip>
        </Container>
    )
}


const mapStateToProps = ({ demandState, locationState, categoryState }) => ({
    categories: categoryState.categories,
    demands: demandState.allDemands,
    cities: locationState.localizations.map((city) => ({ value: city.cityName, display: city.cityName, stateCode: city.state.stateCode })),
    states: distinct(locationState.localizations.map((city) => ({ value: city.state.stateCode, display: city.state.state })), "value")
        .sort((a, b) => {
            if (a.display < b.display)
                return -1;
            if (a.display > b.display)
                return 1;
            return 0;
        })
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ showWarning, showSuccess, cleanDemand }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(GoldenDemandsScreen);